export default "__VITE_ASSET__BLksTfvl__"